import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
html, body, #root {
  height: 100%;
  background: ${({ theme }) => theme.palette.background.default};
}
body{
  margin: 0px !important;
  font-family: 'Montserrat', sans-serif;
}
h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0px !important;
    margin-top: 0px !important;

}
.ant-input-number-group-wrapper{
    width: 100%
}
.ant-input-affix-wrapper-disabled{
  color: ${({ theme }) => theme.palette.black};
}
.ant-input[disabled]{
  color: ${({ theme }) => theme.palette.black};
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.ant-tour {
    width: auto !important;
}
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill,
.ant-input-affix-wrapper>input.ant-input:focus,
.ant-input-outlined:focus-within, .ant-select-selector {
  -webkit-box-shadow: 0 0 0 1000px ${({ theme }) =>
    theme.palette.background.container} inset !important;
    box-shadow: 0 0 0 1000px ${({ theme }) =>
      theme.palette.background.container} inset !important;
  -webkit-text-fill-color: ${({ theme }) =>
    theme.palette.text.primary}  !important;
}
`;

export default GlobalStyles;
